import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
     <ng-container *transloco="let t; read: 'footer'">
     <span>
       {{ t('copyright', { year: currentYear }) }}
     </span>
     </ng-container>
     `,
    })
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
